import { render, staticRenderFns } from "./taobao_shangou_gzh.vue?vue&type=template&id=0d4a62af&scoped=true&"
import script from "./taobao_shangou_gzh.vue?vue&type=script&lang=js&"
export * from "./taobao_shangou_gzh.vue?vue&type=script&lang=js&"
import style0 from "./taobao_shangou_gzh.vue?vue&type=style&index=0&id=0d4a62af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a62af",
  null
  
)

export default component.exports